module.exports = __webpack_public_path__ + "static/media/LYjMdG_8nE8jDLRbgCZ4rA.0caac25d.woff2";